export default "__VITE_ASSET__CDE1TzEn__"